export default __webpack_public_path__ + "static/media/ellipse.a641c291.png";